const DEFAULT_DWORKS_API_BASE = "https://dworks-api.onrender.com";
const configuredApiBase = String(process.env.REACT_APP_DWORKS_API_BASE || "").trim();

export const DWORKS_API_BASE = (configuredApiBase || DEFAULT_DWORKS_API_BASE).replace(/\/+$/, "");

// Google Play/App Store 심사용 네이티브 패키지에서는 결제와 외부 구매 동선을 비활성화합니다.
// 웹 배포는 기본값 false이며 기존 Toss Payments 결제 흐름을 유지합니다.
export const DWORKS_STORE_BUILD = process.env.REACT_APP_DWORKS_STORE_BUILD === "true";

// 결제 화면 비활성화와 출시 기간 기능 제공용 스위치입니다.
// 무료 발주 권한은 서버에서 가입일 + 달력 3개월로 별도 검증합니다.
export const DWORKS_FREE_LAUNCH_MODE = true;

// 무료 운영 기간 브랜드/클라이언트 생성 한도
export const DWORKS_FREE_LAUNCH_BRAND_LIMIT = 5;

// 구버전 필드 호환용 기본값입니다. 실제 무료 정책은 서버의 가입일 + 3개월이며 건수 제한은 없습니다.
export const DWORKS_PROMO_TRIAL_DAYS = 30;
export const DWORKS_PROMO_ORDER_LIMIT = 150;

// 기존 사용량 안내 기준
// 무료 출시 모드에서는 사용하지 않습니다.
export const DWORKS_USAGE_PUSH_THRESHOLD = 10;

// 전달 실패 푸시 테스트 전용 스위치입니다.
// 스토어 빌드에서는 환경변수 설정과 관계없이 항상 비활성화합니다.
// 웹 내부 시험에서도 명시적으로 true를 설정한 경우에만 활성화됩니다.
export const FORCE_DISPATCH_FAILURE_FOR_TEST =
  !DWORKS_STORE_BUILD &&
  process.env.REACT_APP_DWORKS_FORCE_DISPATCH_FAILURE_FOR_TEST === "true";

